import React, { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { add, search, getEncryptedPassword, addPA } from '../../context/users/UserActions'
import { DEFAULT_REGISTRATION_PLAN_ID, DEFAULT_LICENSES_NUMBER } from '../../constants/registration'
import { useUserContext } from '../../context/users/UserContext'
import { 
  FaEye, 
  FaEyeSlash, 
  FaUserPlus, 
  FaEnvelope, 
  FaUser, 
  FaGlobe, 
  FaSave, 
  FaShieldAlt,
  FaExclamationTriangle,
  FaCheckCircle,
  FaBuilding,
  FaIndustry,
  FaUserTie,
  FaUsers,
  FaSpinner
} from 'react-icons/fa'
import { Card, Row, Col, Form, Button } from 'react-bootstrap'
import './AddUser.css'

// eslint-disable-next-line
export default function (props) {
  const EMAIL_REGEX = /[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,3}$/
  const navigate = useNavigate()
  const { uses, industries, authenticateUser, setIndustries, setUses, setAlert, setToken } = useUserContext()

  const [isIndividual, setIndividual] = useState(true)
  const [isOrganizational, setOrganizational] = useState(false)
  const [userEmail, setEmail] = useState('')
  const [validEmail, setValidEmail] = useState(true)
  const [emailTouched, setEmailTouched] = useState(false)
  const [password, setPass] = useState('')
  const [showPass, setShowPass] = useState(false)
  const [showConfirmPass, setShowConfirmPass] = useState(false)
  const [confirmPassword, setConfirmPass] = useState('')
  const [firstName, setFirstName] = useState('')
  const [lastName, setLastName] = useState('')
  const [country, setCountry] = useState('')
  const [useId, setUseId] = useState('')

  const [organization, setOrganization] = useState('')
  const [industryId, setIndustryId] = useState('')
  const [position, setPosition] = useState('')
  const [isLoading, setIsLoading] = useState(false)
  
  const handleChangeFormType = () => {
    setIndividual(!isIndividual)
    setOrganizational(!isOrganizational)
  }

  const handleChangeShowPass = (e) => {
    e.preventDefault()
    const type = showPass ? false : true
    setShowPass(type)
  }

  const handleChangeShowConfirmPass = (e) => {
    e.preventDefault()
    const type = showConfirmPass ? false : true
    setShowConfirmPass(type)
  }

  const handleChangeEmail = (e) => {
    setEmail(e.target.value)
    if(e.target.value === '') {
      setValidEmail(true)
    } else {
      setValidEmail(EMAIL_REGEX.test(e.target.value))
    }
  }

  const handleBlurEmail = () => {
    setEmailTouched(true)
  }

  const handleChangePass = (e) => setPass(e.target.value)
  const handleChangeConfirmPass = (e) => setConfirmPass(e.target.value)
  const handleChangeFirstName = (e) => setFirstName(e.target.value)
  const handleChangeLastName = (e) => setLastName(e.target.value)
  const handleChangeCountry = (e) => setCountry(e.target.value)
  const handleChangeUseId = (e) => setUseId(e.target.value)

  const handleChangeOrganization = (e) => setOrganization(e.target.value)
  const handleChangeIndustryId = (e) => setIndustryId(e.target.value)
  const handleChangePosition = (e) => setPosition(e.target.value)

  const handleSubmit = async (e) => {
    e.preventDefault()
    setIsLoading(true)

    if(!validEmail) {
      setAlert({
        message: 'Por favor ingresa el correo electrónico con formato válido.',
        msgType: 'warning'
      })
      setIsLoading(false)
      return
    } else if(password !== confirmPassword) {
      setAlert({
        message: 'La contraseña es diferente en campo de confirmación',
        msgType: 'warning'
      })
      setIsLoading(false)
      return
    } else if(userEmail === '' || password === '' || firstName === '' || lastName === '' || country === '') {
      setAlert({
        message: 'Por favor ingresa todos los datos requeridos',
        msgType: 'warning'
      })
      setIsLoading(false)
      return
    }

    try {
      const record = await getEncryptedPassword(password)

      let userData = await add({ path: 'users/registry',
      data: {
        userEmail: userEmail.trim(),
        userPass: record.userPass.trim(),
        firstName,
        lastName,
        country,
        useId: !isIndividual ? undefined : useId,
        organization: !isOrganizational ? undefined : organization,
        industryId: !isOrganizational ? undefined : industryId,
        position: !isOrganizational ? undefined : position,
        host: window.location.origin,
        roles: isIndividual ? ['ANFITRION_PER'] : ['ANFITRION_ORG'],
        pendingPlan: false,
      }, 
      token: '' })

      if(Object.prototype.hasOwnProperty.call(userData, 'userId')) {
        userData = {
          ...userData,
          value: userData.token
        }
        try {
          const planData = await addPA({
            path: 'memberships',
            data: {
              userId: userData.userId,
              licensesNumber: DEFAULT_LICENSES_NUMBER,
              planId: DEFAULT_REGISTRATION_PLAN_ID,
            },
            token: userData.token,
          })
          if (!Object.prototype.hasOwnProperty.call(planData, 'planId')) {
            setAlert({
              message:
                planData?.message ||
                'Cuenta creada, pero no se pudo asignar el plan por defecto. Al iniciar sesión podés completar tu plan.',
              msgType: 'warning',
            })
          }
        } catch {
          setAlert({
            message:
              'Cuenta creada, pero hubo un error al asignar el plan. Al iniciar sesión podés elegir un plan.',
            msgType: 'warning',
          })
        }
        navigate('/welcome')
      } else {
        setAlert({
          message: userData.message || userData,
          msgType: 'warning'
        })
      }
    } catch (error) {
      setAlert({
        message: 'Error en el servidor. Por favor intenta más tarde.',
        msgType: 'warning'
      })
    } finally {
      setIsLoading(false)
    }
  }

  const fetchData = async () => {
    let response = []
    response = await search({ path: 'uses', type: 'independiente', token: '' })
    if (response.error) {
      setUses([])
    } else {
      setUses(response.data)
    }

    response = await search({ path: 'industries', token: '' })
    if (response.error) {
      setIndustries([])
    } else {
      setIndustries(response.data)
    }
  }

  useEffect(() => {
    fetchData()
  }, [])

  return (
    <div className="add-user-container">
      <div className="container">
        <Row className="justify-content-center">
          <Col lg={8} md={10} sm={12}>
            {/* Header */}
            <div className="page-header">
              <div className="header-content">
                <div className="header-icon">
                  <FaUserPlus />
                </div>
                <div className="header-text">
                  <h1>Registro de Usuario</h1>
                  <p>Completa la información para registrarte en la plataforma</p>
                </div>
              </div>
            </div>

            {/* Form Card */}
            <Card className="form-card">
              <Card.Body>
                <Form onSubmit={handleSubmit}>
                  {/* License Type Selection */}
                  <Row className="mb-4">
                    <Col lg={12} className="mb-3">
                      <div className="license-type-selection">
                        <h5 className="mb-3">Tipo de Registro</h5>
                        <Row>
                          <Col lg={6} md={12} className="mb-3">
                            <div className={`license-options ${isIndividual ? 'selected' : ''}`}>
                              <div className="license-header">
                                <FaUserTie className="license-icon individual-icon" />
                                <div className="license-title">
                                  <Form.Check
                                    type="radio"
                                    id="individual"
                                    name="licenseType"
                                    label="Registro Independiente"
                                    checked={isIndividual}
                                    onChange={handleChangeFormType}
                                    className="license-option"
                                  />
                                </div>
                              </div>
                              <Form.Text className="license-help">
                                Voy a registrarme como usuario independiente y probarlo gratis
                              </Form.Text>
                            </div>
                          </Col>
                        </Row>
                      </div>
                    </Col>
                  </Row>

                  <Row>
                    {/* Email Field */}
                    <Col lg={6} md={12} className="mb-4">
                      <Form.Group>
                        <Form.Label className="form-label">
                          <FaEnvelope className="field-icon" />
                          Correo Electrónico
                          <span className="required-field">*</span>
                        </Form.Label>
                        <Form.Control
                          type="email"
                          placeholder="usuario@ejemplo.com"
                          value={userEmail}
                          onChange={handleChangeEmail}
                          onBlur={handleBlurEmail}
                          className={`form-control-custom ${!validEmail && emailTouched ? 'is-invalid' : ''}`}
                        />
                        {!validEmail && emailTouched && (
                          <div className="error-message">
                            <FaExclamationTriangle className="error-icon" />
                            Correo con formato inválido
                          </div>
                        )}
                      </Form.Group>
                    </Col>

                    {/* Password Field */}
                    <Col lg={6} md={12} className="mb-4">
                      <Form.Group>
                        <Form.Label className="form-label">
                          <FaShieldAlt className="field-icon" />
                          Contraseña
                          <span className="required-field">*</span>
                        </Form.Label>
                        <div className="password-field">
                          <Form.Control
                            type={showPass ? 'text' : 'password'}
                            placeholder="Ingresa tu contraseña"
                            value={password}
                            onChange={handleChangePass}
                            className="form-control-custom"
                          />
                          {password && (
                            <button 
                              type="button"
                              className="eye-button"
                              onClick={handleChangeShowPass}
                              aria-label={showPass ? 'Ocultar contraseña' : 'Mostrar contraseña'}
                            >
                              {showPass ? <FaEyeSlash /> : <FaEye />}
                            </button>
                          )}
                        </div>
                      </Form.Group>
                    </Col>

                    {/* Confirm Password Field */}
                    <Col lg={6} md={12} className="mb-4">
                      <Form.Group>
                        <Form.Label className="form-label">
                          <FaShieldAlt className="field-icon" />
                          Confirmar Contraseña
                          <span className="required-field">*</span>
                        </Form.Label>
                        <div className="password-field">
                          <Form.Control
                            type={showConfirmPass ? 'text' : 'password'}
                            placeholder="Confirma tu contraseña"
                            value={confirmPassword}
                            onChange={handleChangeConfirmPass}
                            className="form-control-custom"
                          />
                          {confirmPassword && (
                            <button 
                              type="button"
                              className="eye-button"
                              onClick={handleChangeShowConfirmPass}
                              aria-label={showConfirmPass ? 'Ocultar contraseña' : 'Mostrar contraseña'}
                            >
                              {showConfirmPass ? <FaEyeSlash /> : <FaEye />}
                            </button>
                          )}
                        </div>
                      </Form.Group>
                    </Col>
                  </Row>

                  {/* Individual License Fields */}
                  {isIndividual && (
                    <Row>
                      <Col lg={6} md={12} className="mb-4">
                        <Form.Group>
                          <Form.Label className="form-label">
                            <FaUser className="field-icon" />
                            Nombre
                            <span className="required-field">*</span>
                          </Form.Label>
                          <Form.Control
                            type="text"
                            placeholder="Nombre del usuario"
                            value={firstName}
                            onChange={handleChangeFirstName}
                            className="form-control-custom"
                          />
                        </Form.Group>
                      </Col>

                      <Col lg={6} md={12} className="mb-4">
                        <Form.Group>
                          <Form.Label className="form-label">
                            <FaUser className="field-icon" />
                            Apellidos
                            <span className="required-field">*</span>
                          </Form.Label>
                          <Form.Control
                            type="text"
                            placeholder="Apellidos del usuario"
                            value={lastName}
                            onChange={handleChangeLastName}
                            className="form-control-custom"
                          />
                        </Form.Group>
                      </Col>

                      <Col lg={6} md={12} className="mb-4">
                        <Form.Group>
                          <Form.Label className="form-label">
                            <FaGlobe className="field-icon" />
                            País de Residencia
                            <span className="required-field">*</span>
                          </Form.Label>
                          <Form.Control
                            type="text"
                            placeholder="País donde reside el usuario"
                            value={country}
                            onChange={handleChangeCountry}
                            className="form-control-custom"
                          />
                        </Form.Group>
                      </Col>

                      <Col lg={6} md={12} className="mb-4">
                        <Form.Group>
                          <Form.Label className="form-label">
                            <FaIndustry className="field-icon" />
                            Uso Principal
                            <span className="required-field">*</span>
                          </Form.Label>
                          <Form.Select
                            value={useId}
                            onChange={handleChangeUseId}
                            className="form-control-custom"
                          >
                            <option value="">Selecciona una opción</option>
                            {uses.map((option) => (
                              <option key={option.id} value={option.id}>
                                {option.name}
                              </option>
                            ))}
                          </Form.Select>
                        </Form.Group>
                      </Col>
                    </Row>
                  )}

                  {/* Action Buttons */}
                  <div className="form-actions">
                    <Button
                      type="button"
                      variant="outline-secondary"
                      className="cancel-button"
                      onClick={() => navigate('/login')}
                    >
                      Volver al inicio de sesión
                    </Button>
                    <Button
                      type="submit"
                      variant="primary"
                      className="save-button"
                      disabled={isLoading}
                    >
                      {isLoading ? (
                        <>
                          <FaSpinner className="me-2 spinner-icon" />
                          Registrando...
                        </>
                      ) : (
                        <>
                          <FaSave className="me-2" />
                          Registrar
                        </>
                      )}
                    </Button>
                  </div>
                </Form>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </div>
    </div>
  )
}
